module.exports = __webpack_public_path__ + "static/media/metamask.cf88593e.svg";